export const SUSHI_REQUEST_HEADERS = {
    'Origin': 'https://sushi.com'
};
